/**
 * useClvTrends Hook (Web)
 * Thin wrapper around shared useClvTrends
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import {
  type UseClvTrendsResult,
  useClvTrends as useClvTrendsShared,
} from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

export type { UseClvTrendsResult };

export function useClvTrends(): UseClvTrendsResult {
  const { authFetch } = useAuth();
  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );
  return useClvTrendsShared({ httpClient });
}
